module.exports = __webpack_public_path__ + "img/loader.c76cdb03.svg";